// @ts-nocheck
import React from "react";
import { connect } from "react-redux";
import ProgramDetails from "./ProgramDetails";
import ProgramDetailsDisconnect from "./ProgramDetailsDisconnect";
import { transactionType } from "../../Page/TransactionSummaryPage/Shared/Constants";
import SubscriberSection from "./SubscriberSection";
import { setSubscriber } from "../../Page/TransactionSummaryPage/TransactionSummarySlice";

const ProgramDetailsBlock = ({
  data,
  context,
  offerName,
  monthlyPaymentsSummary,
  programDescription,
  dealType,
  allSubscribers,
  currentSubscriber,
  setSubscriber,
  generalDetails,
  disconnectedServicesAndEquipments,
}) => {
  let programDetailsComponent = <div></div>;
  console.log("generalDetails?.family new one  "+ generalDetails?.family );
  console.log("dealType "+ dealType );
  switch (dealType) {
    case transactionType.Disconnect:
      programDetailsComponent = (
        <React.Fragment>
          {allSubscribers.length > 1 && (
            <SubscriberSection
              allSubscribers={allSubscribers}
              currentSubscriber={currentSubscriber}
              setSubscriber={setSubscriber}
            />
          )}
          <ProgramDetailsDisconnect
            dealType={dealType}
            disconnectedServicesAndEquipments={
              disconnectedServicesAndEquipments
            }
            context={context}
          />
        </React.Fragment>
      );
      break;
    case transactionType.Replace:
      programDetailsComponent = (
        <React.Fragment>
          {allSubscribers.length > 1 && (
            <SubscriberSection
              allSubscribers={allSubscribers}
              currentSubscriber={currentSubscriber}
              setSubscriber={setSubscriber}
            />
          )}
          <ProgramDetailsDisconnect
            dealType={dealType}
            disconnectedServicesAndEquipments={
              disconnectedServicesAndEquipments
            }
            context={context}
          />
          <ProgramDetails
            data={data}
            context={context}
            offerName={offerName}
            monthlyPaymentsSummary={monthlyPaymentsSummary}
            programDescription={programDescription}
            currentSubscriber={currentSubscriber}
            generalDetails={generalDetails}
          />
        </React.Fragment>
      );
      break;
    case transactionType.Provide:
      programDetailsComponent = (
        <React.Fragment>
          {allSubscribers.length > 1 && (
            <SubscriberSection
              allSubscribers={allSubscribers}
              currentSubscriber={currentSubscriber}
              setSubscriber={setSubscriber}
            />
          )}
          <ProgramDetails
            data={data}
            context={context}
            offerName={offerName}
            monthlyPaymentsSummary={monthlyPaymentsSummary}
            programDescription={programDescription}
            currentSubscriber={currentSubscriber}
            generalDetails={generalDetails}
          />
        </React.Fragment>
      );
      break;
    case transactionType.Change:
      programDetailsComponent = (
          <React.Fragment>
            {allSubscribers.length > 1 && (
                <SubscriberSection
                    allSubscribers={allSubscribers}
                    currentSubscriber={currentSubscriber}
                    setSubscriber={setSubscriber}
                />
            )}
            <ProgramDetails
                data={data}
                context={context}
                offerName={offerName}
                monthlyPaymentsSummary={monthlyPaymentsSummary}
                programDescription={programDescription}
                currentSubscriber={currentSubscriber}
                generalDetails={generalDetails}
            />
          </React.Fragment>
      );
      break;
    default:

      break;
  }

  return  programDetailsComponent;
};

const mapStateToProps = (state) => {
  return {
    offerName:
      state.cellcomTransactionSummary.transactionData.generalDetails?.offerName,
    monthlyPaymentsSummary:
      state.cellcomTransactionSummary.transactionData.monthlyPaymentsSummary,
    programDescription:
      state.cellcomTransactionSummary.transactionData.programDetails,
    disconnectedServicesAndEquipments:
      state.cellcomTransactionSummary.transactionData
        .disconnectedServicesAndEquipments,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    allSubscribers:
      state.cellcomTransactionSummary.transactionData.generalDetails
        .subscriberNumberList,
    currentSubscriber: state.cellcomTransactionSummary.callular,
    generalDetails:
      state.cellcomTransactionSummary.transactionData.generalDetails,
  };
};
const mapDispatchToProps = {
  setSubscriber,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProgramDetailsBlock);
